<template>
    <el-dialog
        :title="unpaidDetails.is_bad_debt == 1 ? '坏账详情' : '未回款详情'"
        :visible.sync="unpaidDetailsDialogVisible"
        width="800px"
        :before-close="handleDetailDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-payable-detail_dialog"
    >
        <div class="page_little_title">基本信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="客户公司名称">
                        <el-link
                            type="primary"
                            v-text="unpaidDetails.basic_info.customer_name"
                            :underline="false"
                            @click="
                                handleClickCustomerDetail(
                                    unpaidDetails.basic_info.customer_id,
                                    unpaidDetails.basic_info.customer_name
                                )
                            "
                        >
                        </el-link>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="订单编号">
                        <el-link
                            type="primary"
                            v-text="unpaidDetails.basic_info.order_num"
                            :underline="false"
                            @click="handleClickOrderDetail(unpaidDetails.basic_info.order_num)"
                        >
                        </el-link>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户负责人">
                        <div v-text="unpaidDetails.basic_info.salesperson_name || '--'"></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="部门负责人">
                        <div
                            v-if="
                                unpaidDetails.basic_info.department_leader &&
                                unpaidDetails.basic_info.department_leader.length
                            "
                        >
                            {{ unpaidDetails.basic_info.department_leader.map((item) => item.name).join("、") }}
                        </div>
                        <div v-else>
                            --
                        </div>
                    </el-form-item>
                </el-col>
                <template v-if="unpaidDetails.is_bad_debt == 1">
                    <el-col :span="12">
                        <el-form-item label="处理人">
                            <div
                                v-text="
                                    (unpaidDetails.basic_info.mark_operate_info &&
                                    unpaidDetails.basic_info.mark_operate_info.name) || '--'
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="处理日期">
                            <div v-text="unpaidDetails.basic_info.mark_operate_time || '--'"></div>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
        </el-form>
        <div class="page_little_title">金额信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="订单总金额">
                        <div
                            v-text="
                                Number(unpaidDetails.amount_info.total_price).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="已回款总金额">
                        <div
                            v-text="
                                Number(unpaidDetails.amount_info.total_repay_price).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="未回款金额">
                        <div
                            v-text="
                                Number(unpaidDetails.amount_info.no_repay_price).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="unpaidDetails.is_bad_debt == 1">
                    <el-form-item label="坏账金额">
                        <div
                            v-text="
                                Number(unpaidDetails.amount_info.bad_debt_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <template v-if="unpaidDetails.is_bad_debt == 1">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div
                                v-text="unpaidDetails.other_info.remark"
                                v-if="unpaidDetails.other_info.remark"
                                class="remark_text"
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="附件">
                            <div
                                class="file_upload_wrap file_upload_detail_wrap"
                                v-if="unpaidDetails.other_info.attachment && unpaidDetails.other_info.attachment.length"
                            >
                                <ul class="upload_file_list upload_file_list_detail">
                                    <li v-for="file in unpaidDetails.other_info.attachment" class="upload_file_item">
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <el-image
                :preview-src-list="previewImgList"
                :src="previewImgSrc"
                ref="preview_img"
                style="display: none"
            ></el-image>
        </el-form>
        <!-- <span slot="footer" class="dialog-footer" v-if="unpaidDetails.is_bad_debt == 0">
            <el-button type="primary" @click.stop="handleClickDemandPayment" :disabled="btnDisabled">催款</el-button>
            <el-button type="primary" @click.stop="handleClickBadDebt" :disabled="btnDisabled">坏账</el-button>
        </span> -->
    </el-dialog>
</template>
<script>
import { OrderUnpaidDetail } from "@/api";
import { getOSSData } from "@/utils/uploadOss";
export default {
    name: "UnpaidPaymentDetails",
    props: {
        unpaidDetailsDialogVisible: {
            type: Boolean,
            default: false,
        },
        order_num: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
            unpaidDetails: {
                is_bad_debt: 0, // 1坏账 0正常
                basic_info: {},
                amount_info: {},
                other_info: {},
            },
            btnDisabled: false,

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    created() {
        if (this.order_num) {
            this.getOrderUnpaidDetail();
        }
    },
    methods: {
        handleDetailDialogClose() {
            this.$emit("update:unpaidDetailsDialogVisible", false);
        },
        // 详情
        getOrderUnpaidDetail() {
            OrderUnpaidDetail({ order_num: this.order_num }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.unpaidDetails = data;
                }
            });
        },
        // 催款
        handleClickDemandPayment() {
            this.$emit("btnOperate", { type: "demandPayment", row: { order_num: this.order_num } });
        },
        // 坏账
        handleClickBadDebt() {
            this.$emit("btnOperate", { type: "badDebt", row: { order_num: this.order_num } });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(order_num) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_num,
                    name: order_num,
                    query_type: "order_no",
                },
            });
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}
.custom-payable-detail_dialog {
    .el-dialog__body {
        max-height: 660px;
        overflow-y: auto;
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .voucher_item {
            width: 48px;
            height: 48px;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
    }
    .remark_text {
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(237, 240, 244, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }
    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
    .file_upload_detail_wrap {
        height: auto;
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}
</style>
